// Отображение срабатывания ловушки(ек) Гоблинов по отряду - чисто
// клиентское состояние (см. add-goblins-faction design.md Decision 12/20/21),
// не синхронизируется по сети. Обслуживает ДВЕ разные вещи одним объектом:
// 1) блокирующее уведомление (только на клиенте игрока-человека, чей отряд
//    сейчас двигается) - некровное, не затемняет экран, в отличие от
//    ModalWindow, показывается ТОЛЬКО когда blocking: true;
// 2) индикаторы на поле (иконки ловушек с уроном на их гексах + "-N" под
//    отрядом, см. HexGridRenderer.updateGoblinsTrapTriggerDisplay) - рисуются
//    для ЛЮБОГО срабатывания (в т.ч. бота), пока show: true, независимо от
//    blocking, и держатся до конца этапа перемещения/маневра (сброс по
//    COMPLETE_PHASE/SET_WAR_PHASE_STAGE ниже). Раньше их снимал таймер на
//    2.5 с, а на своем ходу — тот же клик, что закрывал карточку: игрок
//    кликал по полю и терял всю картину срабатывания (найдено пользователем).
//    Последнее срабатывание по-прежнему перекрывает предыдущее, если их было
//    несколько подряд — принятый компромисс ради простоты (см. design.md Risks)
const initialState = {
  show: false,
  blocking: false,
  // Карточка на экране (только при blocking). Отдельно от show: закрытие
  // карточки — кликом или таймером GOBLINS_TRAP_KILL_NOTICE_AUTO_HIDE_MS — не
  // должно уносить с поля индикаторы срабатывания: они живут до конца этапа
  isNoticeVisible: false,
  unit: null,
  died: false,
  finalHexKey: null,
  totalDamageTaken: 0,
  triggeredTrapEvents: [],
};

const goblinsTrapKillNoticeReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SHOW_GOBLINS_TRAP_KILL_NOTICE':
      return {
        show: true,
        blocking: Boolean(action.payload.blocking),
        isNoticeVisible: Boolean(action.payload.blocking),
        unit: action.payload.unit || null,
        died: Boolean(action.payload.died),
        finalHexKey: action.payload.finalHexKey || null,
        totalDamageTaken: action.payload.totalDamageTaken || 0,
        triggeredTrapEvents: action.payload.triggeredTrapEvents || [],
      };
    // Гасит ТОЛЬКО карточку: индикаторы на поле (плашки урона по ловушкам,
    // «-N» под отрядом, призрак погибшего) остаются до смены этапа/хода —
    // иначе они пропадали от первого же клика игрока по полю
    case 'HIDE_GOBLINS_TRAP_KILL_NOTICE':
      return state.isNoticeVisible ? {...state, isNoticeVisible: false} : state;
    // Смена хода (COMPLETE_PHASE) или этапа фазы войны (SET_WAR_PHASE_STAGE)
    // не сбрасывалась вовсе - если к этому моменту уведомление ещё не было
    // закрыто кликом (blocking: true) или таймером (blocking: false), на
    // экране навсегда оставался полноэкранный перехватчик клика
    // (.goblins-trap-kill-notice_catcher), проглатывающий следующий клик, и
    // устаревшие плашки урона на поле. Для blocking: true это реально
    // достижимо в сетевой игре - сервер может форсированно завершить этап
    // по таймеру хода, пока локальное блокирующее уведомление ещё не
    // закрыто игроком (найдено внешним ревью ветки add-goblins-faction). Тот
    // же принцип сброса при смене хода/этапа, что уже применяет
    // selectedEntitiesReducer к своим полям
    case 'COMPLETE_PHASE':
    case 'SET_WAR_PHASE_STAGE':
      return state.show ? {...initialState} : state;
    // Загрузка состояния — вход в матч, ресинк после разрыва, перемотка
    // записи: показанное срабатывание относится к другому моменту партии, а
    // таймера, который раньше снимал его сам, больше нет (индикаторы живут до
    // конца этапа)
    case 'LOAD_STATE':
      return state.show ? {...initialState} : state;
    default:
      return state;
  }
};

export default goblinsTrapKillNoticeReducer;
